import React from "react";
import { BookButton } from "../ui/BookButton";
import { useTranslation } from "react-i18next";

export const SearchCard = () => {
  const { t } = useTranslation();
  // const carouselRef = useRef<HTMLDivElement>(null);
  // const intervalRef = useRef<NodeJS.Timeout | null>(null);
  // const scrollSpeed = 300;
  // const scrollInterval = 6000;

  // const startAutoScroll = () => {
  //   if (intervalRef.current) clearInterval(intervalRef.current);
  //   intervalRef.current = setInterval(() => {
  //     if (carouselRef.current) {
  //       carouselRef.current.scrollBy({ left: scrollSpeed, behavior: "smooth" });
  //       if (
  //         carouselRef.current.scrollLeft + carouselRef.current.offsetWidth >=
  //         carouselRef.current.scrollWidth
  //       ) {
  //         carouselRef.current.scrollTo({ left: 0, behavior: "smooth" });
  //       }
  //     }
  //   }, scrollInterval);
  // };

  // useEffect(() => {
  //   startAutoScroll();
  //   return () => {
  //     if (intervalRef.current) clearInterval(intervalRef.current);
  //   };
  // }, []);

  // const resetAutoScroll = () => {
  //   if (intervalRef.current) clearInterval(intervalRef.current);
  //   startAutoScroll();
  // };

  // const scrollLeft = () => {
  //   if (carouselRef.current) {
  //     if (carouselRef.current.scrollLeft === 0) {
  //       carouselRef.current.scrollTo({
  //         left: carouselRef.current.scrollWidth,
  //         behavior: "smooth",
  //       });
  //     } else {
  //       carouselRef.current.scrollBy({
  //         left: -scrollSpeed,
  //         behavior: "smooth",
  //       });
  //     }
  //   }
  //   resetAutoScroll();
  // };

  // const scrollRight = () => {
  //   if (carouselRef.current) {
  //     if (
  //       carouselRef.current.scrollLeft + carouselRef.current.offsetWidth >=
  //       carouselRef.current.scrollWidth - 1
  //     ) {
  //       carouselRef.current.scrollTo({ left: 0, behavior: "smooth" });
  //     } else {
  //       carouselRef.current.scrollBy({ left: scrollSpeed, behavior: "smooth" });
  //     }
  //   }
  //   resetAutoScroll();
  // };

  return (
    <div className="flex flex-col justify-center items-center">
      <div
        style={{
          background:
            "conic-gradient(from 129deg at -11.1% -16.73%, rgba(239, 230, 255, 0.34) 30.116258561611176deg, rgba(255, 255, 255, 0.34) 47.14591205120087deg, rgba(239, 230, 255, 0.34) 66.65989995002747deg, rgba(255, 255, 255, 0.34) 73.7626576423645deg, rgba(239, 230, 255, 0.34) 244.48787927627563deg, rgba(255, 255, 255, 0.34) 337.70099401474deg, rgba(239, 230, 255, 0.34) 344.95684146881104deg, rgba(255, 255, 255, 0.34) 360deg), #FFF",
        }}
        className="rounded-[13px] border-[1px] border-primary-600 flex flex-col gap-5-res w-[90%] md:w-[70%] max-w-[800px] py-6-res"
      >
        <p className="text-primary-700 text-center font-[500] italic text-[20px] md:text-[32px] lg:text-[40px] leading-[24px] md:leading-[30px] lg:leading-[56px] tracking-[-0.78px]">
          {String(t("sharedCard.title"))}
        </p>
        <p className="text-neutral-200 text-center font-[500] text-[14px] leading-normal tracking-[-0.28px]">
          {String(t("sharedCard.subtitle"))}
        </p>
        <div className="w-full text-center">
          <BookButton />
        </div>
      </div>

      {/* <p className="text-primary-700 text-[24px] md:text-[32px] lg:text-[40px] font-600 tracking-[-1.2px] self-center mt-[45px] lg:mt-[62px] mb-[40px] lg:mb-[56px]">
        {TITLES.TESTIMONIALS_CARD_TITLE}
      </p>


      <div className="relative w-full max-w-[1200px] mt-[20px] mx-[40px]">
        <div
          ref={carouselRef}
          className="flex gap-[40px] flex-wrap md:flex-nowrap scrollbar-hide scroll-smooth justify-center md:justify-start px-4 overflow-x-auto"
        >
          {TestimonialsData.map((eachCard, index) => (
            <TestimonialCard
              testimonial={eachCard.testimonial}
              author={eachCard.author}
              key={index}
            />
          ))}
        </div>

        <div className="hidden md:flex justify-center mt-4 flex-row gap-6">
          <button
            onClick={scrollLeft}
            className="p-2 border-[1px] border-neutral-800 flex items-center justify-center h-[40px] w-[40px] text-neutral-700 rounded-full shadow-md hover:bg-primary-600 transition-colors duration-300"
          >
            <FaArrowLeft />
          </button>
          <button
            onClick={scrollRight}
            className="p-2 border-[1px] border-neutral-800 flex h-[40px] items-center justify-center w-[40px] text-neutral-700 rounded-full shadow-md hover:bg-primary-600 transition-colors duration-300"
          >
            <FaArrowRight />
          </button>
        </div>
      </div> */}
    </div>
  );
};
